'use client'

import { useEffect, useRef } from "react"
import styles from "./ua.module.scss";
import Button from "@/components/button/Button";
import Icon from "@/components/icon/Icon";
import useEventListener, { emitEvent } from "@/components/plugins/EventListener";
import DealerSelectorPopup from "../dealers/DealerSelectorPopup";

export default function HeaderServiceButton(props) {
  
  const popup = useRef()

  useEventListener("show_schedule_service", event => {
    if (event.detail.mobile && props.item.mobile_only) {
      popup.current.show()
    }
  })

  useEffect(() => {
  }, [])
  
  const onToggle = () => {
    popup.current.show()
  }
  
  return <>
    <Button plain={true} className={ styles.mi + " " + props.className } onClick={e => onToggle(e)} label={ props.label }>
      { props.item?.icon &&
      <Icon {...props} name="calendar"></Icon>
      }
    </Button>
    <DealerSelectorPopup ref={popup} {...props}></DealerSelectorPopup>
  </>

  
}